"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VariableStorageService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
/**
 * @category Storage
 */
var VariableStorageService = /** @class */ (function () {
    function VariableStorageService() {
        this.map = new Map();
    }
    VariableStorageService.prototype.getAllKeys = function (filter) {
        var keys = Array.from(this.map.keys());
        if (filter) {
            keys = keys.filter(filter);
        }
        return keys;
    };
    VariableStorageService.prototype.getItem = function (key) {
        return this.map.get(key) || null;
    };
    VariableStorageService.prototype.getItemAsObject = function (key) {
        return this.map.get(key) || null;
    };
    VariableStorageService.prototype.removeItem = function (key) {
        this.map.delete(key);
    };
    VariableStorageService.prototype.setItem = function (key, value) {
        this.map.set(key, value);
    };
    VariableStorageService = __decorate([
        (0, CommonService_decorator_1.CommonService)('VariableStorageService')
    ], VariableStorageService);
    return VariableStorageService;
}());
exports.VariableStorageService = VariableStorageService;
//# sourceMappingURL=VariableStorage.service.js.map